import { Alert } from "antd";
import { getEnvName, isNonProdEnv } from "../utilities/systemUtility";
import K from "../utilities/constants";

export const EnvironmentAlert = () => {
  if (!isNonProdEnv()) {
    return null;
  }

  const alertStyles = {
    [K.Environment.DEVELOPMENT]: { backgroundColor: "#00d9ff" },
    [K.Environment.QA]: { backgroundColor: "#ff6600" },
    [K.Environment.STAGING]: { backgroundColor: "#3AC73A" },
  };

  return (
    <Alert
      message={getEnvName()}
      banner
      showIcon={false}
      className="env-header"
      style={alertStyles[K.Server] || {}}
    />
  );
};
